//AUTOGENERATED, DO NOT MODIFY, use attributes deriving from ExportStructureAttributeBase to specify for export to this file
export namespace Calculation {
	export enum __vite_fix_ignore_me {}
	export enum ApartmentsPark {
		Social = 'social',
		Private = 'private',
	}
	export enum ApartmentsSituation {
		Normal = 'normal',
		SeaSide = 'seaSide',
		Mountain = 'mountain',
	}
	export enum ApartmentsStanding {
		Normal = 'normal',
		High = 'high',
	}
	export interface AquaEfficiencyTechnicalData {
		model: string;
		nominalCapacity: string;
		singlePrimaryPump: Calculation.ProductVersionTechnicalDataTypeModel;
		doublePrimaryPump: Calculation.ProductVersionTechnicalDataTypeModel;
		singlePrimaryPumpSingleChargingPump: Calculation.ProductVersionTechnicalDataTypeModel;
		doublePrimaryPumpSingleChargingPump: Calculation.ProductVersionTechnicalDataTypeModel;
		doublePrimaryPumpDoubleChargingPump: Calculation.ProductVersionTechnicalDataTypeModel;
		dimensions: string;
		direct: boolean;
		temperatureProgram: string;
		currency: string;
	}
	export interface AquaFirstAndGeniusTechnicalData {
		flowRate: string;
		model: string;
		nominalCapacity: string;
		singlePrimaryPump: Calculation.ProductVersionTechnicalDataTypeModel;
		doublePrimaryPump: Calculation.ProductVersionTechnicalDataTypeModel;
		singlePrimaryPumpSingleChargingPump: Calculation.ProductVersionTechnicalDataTypeModel;
		doublePrimaryPumpSingleChargingPump: Calculation.ProductVersionTechnicalDataTypeModel;
		doublePrimaryPumpDoubleChargingPump: Calculation.ProductVersionTechnicalDataTypeModel;
		dimensions: string;
		direct: boolean;
		temperatureProgram: string;
		currency: string;
	}
	export interface AquaPilotTechnicalData {
		model: string;
		weight: number;
		partnumber: string;
		price: number;
		controlValveDiameter: string;
		controlValveKvs: string;
		primaryFlowRates: number[];
		primaryPressureLosses: number[];
		dimensions: string;
		direct: boolean;
		temperatureProgram: string;
		currency: string;
	}
	export interface AquaPlatePrimarySecondaryParameters {
		capacity: string;
		flowRate: number;
	}
	export interface AquaPlateTechnicalData {
		primaryFlowRate: string;
		primaryPressureDrop: string;
		primary80: Calculation.AquaPlatePrimarySecondaryParameters;
		primary70: Calculation.AquaPlatePrimarySecondaryParameters;
		weight: number;
		partnumber: string;
		price: number;
		dimensions: string;
		direct: boolean;
		temperatureProgram: string;
		currency: string;
	}
	export interface CalculationDocumentationModel {
		type: Calculation.DocumentationType;
		calculation: Calculation.TWSCalculationEditModel;
	}
	export enum CampingsClassification {
		Two = 'two',
		Three = 'three',
		Four = 'four',
		Five = 'five',
	}
	export enum CampingSituation {
		SeaSide = 'seaSide',
		PlainRiver = 'plainRiver',
		Mountain = 'mountain',
	}
	export interface CapacityCalculationMethodModel {
		capacity: number;
		volume: number;
		instantaneous: boolean;
		semiInstantaneous: boolean;
		primaryTank: boolean;
		secondaryTank: boolean;
	}
	export enum ControlValveType {
		All = 0,
		No = 1,
		TwoPE = 2,
		ThreeP = 3,
		ThreePdiv = 4,
	}
	export enum DocumentationType {
		Calculation = 'calculation',
		Project = 'project',
	}
	export interface GenerateDocumentationModel {
		projectId?: number;
		technicalSpecification?: any;
		twsOutcomes: any[];
		language: number;
		documentations: Calculation.CalculationDocumentationModel[];
		publicPriceInclude: boolean;
	}
	export class HEType {
		static all = 'All';
		static bhe = 'BHE';
		static fhe = 'FHE';
		static phe = 'PHE';
	}
	export enum HotelsStanding {
		OneTwo = 'oneTwo',
		ThreeFour = 'threeFour',
		Five = 'five',
	}
	export enum InputMethod {
		InstallationType = 0,
		Capacity = 1,
		ProductCatalog = 2,
	}
	export interface InputMethodModel {
		design: any;
		inputMethod: Calculation.InputMethod;
		inputMethodName: string;
		installationType: Calculation.InstallationType;
		installationTypeName: string;
		installationTypeCalculation: Calculation.InstallationTypeCalculationMethodModel;
		capacityCalculation: Calculation.CapacityCalculationMethodModel;
		productCatalogCalculation: Calculation.ProductCatalogCalculationMethodModel;
		results: Calculation.InstallationTypeCalculationResultModel;
	}
	export enum InstallationType {
		ApartmentsBlocks = 0,
		Hotels = 1,
		Retirement = 2,
		Hospitals = 3,
		Restaurants = 4,
		SportCenters = 5,
		Internats = 6,
		Campings = 7,
	}
	export interface InstallationTypeCalculationMethodModel {
		maxChargingTimeForAccumulation?: number;
		tDhw: number;
		park: Calculation.ApartmentsPark;
		standing: Calculation.ApartmentsStanding;
		situation: Calculation.ApartmentsSituation;
		apartmentsStudio?: number;
		apartmentsT1Room?: number;
		apartmentsT2Room?: number;
		apartmentsT3Room?: number;
		apartmentsT4Room?: number;
		apartmentsT5Room?: number;
		apartmentsT6Room?: number;
		equivalentInStandardApartments?: number;
		primaryTankChargingPtDt: number;
		primaryTankAvailableCapacity?: number;
		primaryTankAquaEfficiency: boolean;
		unitCapacity: number;
		primaryStorage: number;
		madeOf: string;
		selectedUnitModel: Calculation.MatchingUnitModel;
		numberOfBeds: number;
		numberOfShowerRooms: number;
		numberOfShowersPerShowerRoom: number;
		showerConsumption: number;
		showerMeanDuration: number;
		numberMealsBreakfast: number;
		numberMealsLunch: number;
		numberMealsDinner: number;
		restaurantCategory: Calculation.RestaurantsCategory;
		numberOfRooms: number;
		hotelStanding: Calculation.HotelsStanding;
		mountain: boolean;
		bedsPerRoom: number;
		campingClassification: Calculation.CampingsClassification;
		campingSituation: Calculation.CampingSituation;
		sportCenterGymnasiumNumberOfSportHalls: number;
		sportCenterStadiumNumberOfSportGrounds: number;
		pushButtons: boolean;
		apartmentsParkAsText: string;
		apartmentsStandingAsText: string;
		apartmentsSituationAsText: string;
		hotelStandingAsText: string;
		restaurantCategoryAsText: string;
		campingClassificationAsText: string;
		campingSituationAsText: string;
	}
	export interface InstallationTypeCalculationResultModel {
		equivalentInStandardApartments: number;
		primaryTankCalculationError?: Calculation.PrimaryTankCalculationError;
		matchingUnitModels: Calculation.MatchingUnitModel[];
		primaryTankUnitCapacity?: number;
		primaryTankStorage?: number;
		primaryTankMadeOf: string;
		primaryTankFlowRate?: number;
	}
	export interface MatchingTankQuantitiesSelectionResult {
		tankType: Selection.TankType;
		matchingQuantityModels: Selection.MatchingQuantityModel[];
	}
	export interface MatchingTapWaterSystemModel {
		id: string;
		artNo: string;
		prodFamilyDisplayName: string;
		prodFamily: string;
		series: string;
		originalSeries: string;
		tProg: string;
		p: string;
		inst: string;
		primPump: string;
		secPump: string;
		heType: string;
		np: string;
		primKitArtNo: string;
		cv: string;
		description: string;
		image: string;
		flowChart: string;
		technicalDrawing: string;
		parsedP: number;
	}
	export interface MatchingUnitModel {
		p?: number;
		storage: number;
		operatingMode: Calculation.OperatingMode;
		loadTimeWithoutRecycling?: number;
		loadTimeWithRecycling?: number;
		hasPrimaryTank: boolean;
		loadTimeWithoutRecyclingReadable: string;
		loadTimeWithRecyclingReadable: string;
		showOperatingMode: boolean;
		selectedOperatingModeAsText: string;
	}
	export enum OperatingMode {
		Instantaneous = 0,
		SemiInstantaneous = 1,
		SemiAccumulation = 2,
		Accumulation = 3,
		FullAccumulation = 4,
		PrimaryTank = 5,
	}
	export function getOperatingModeName(k: OperatingMode): string {
		switch(k) {
			case OperatingMode.Instantaneous: return 'Instantaneous';
			case OperatingMode.SemiInstantaneous: return 'Semi-Instantaneous';
			case OperatingMode.SemiAccumulation: return 'Semi-Accumulation';
			case OperatingMode.Accumulation: return 'Accumulation';
			case OperatingMode.FullAccumulation: return 'Full Accumulation';
			case OperatingMode.PrimaryTank: return 'Instantaneous + Primary Tank';
		}
	}
	export enum PrimaryTankCalculationError {
		PrimaryTankNotNeeded = 0,
		PrimaryTankVolumeCapacityTooBig = 1,
	}
	export interface ProductCatalogCalculationMethodModel {
		twsFamily: string;
		tankFamily: string;
		tankVolume?: number;
		selectedProduct: Calculation.ProductCatalogItemModel;
		availableProducts: Calculation.ProductCatalogItemModel[];
		temperatureProgram: string;
		instantaneous: boolean;
	}
	export interface ProductCatalogItemModel {
		displayName: string;
		name: string;
		image: string;
		direct: boolean;
		inDirect: boolean;
		plateAndGasketsHeatExchanger: boolean;
		fusionBondedHeatExchanger: boolean;
		copperBrazedHeatExchanger: boolean;
		maxPower: number;
		title: string;
		isTank: boolean;
	}
	export interface ProductDataModel {
		name: string;
		displayName: string;
		mainPhoto: string;
		description: string;
		primaryDesignTemperature?: number;
		secondaryDesignTemperature?: number;
		primaryDesignPressure?: number;
		secondaryDesignPressure?: number;
		technicalData: Calculation.ProductVersionTechTables;
		defaultTemperatureProgramForTable: string;
	}
	export interface ProductVersionTechnicalDataTypeModel {
		weight: number;
		articleNumber: string;
		price: number;
	}
	export interface ProductVersionTechTables {
		aquaFirstTechnicalData: Calculation.AquaFirstAndGeniusTechnicalData[];
		aquaGeniusTechnicalData: Calculation.AquaFirstAndGeniusTechnicalData[];
		aquaPilotTechnicalData: Calculation.AquaPilotTechnicalData[];
		aquaPlateTechnicalData: Calculation.AquaPlateTechnicalData[];
		aquaEfficiencyTechnicalData: Calculation.AquaEfficiencyTechnicalData[];
	}
	export enum RestaurantsCategory {
		Cantine = 'cantine',
		Standard = 'standard',
		Lux = 'lux',
	}
	export enum SelectedWaterSystemPrimaryPressureErrors {
		NoError = 0,
		ConsultWithCtt = 1,
		SelectBiggerValve = 2,
	}
	export interface TankSelectionModel {
		design: any;
		matchingTankUnit: any;
		selectedMatchingTankQuantity: Selection.MatchingQuantityModel;
		matchingTankSelection: any;
		selectedTank: Selection.TankResultModel;
		results: Calculation.TankSelectionResultModel;
	}
	export interface TankSelectionResultModel {
		matchingQuantitiesResultModel: Calculation.MatchingTankQuantitiesSelectionResult;
		tankResults: Selection.TankResultModel[];
		tankTechnicalData: Selection.TankTechnicalDataModel;
	}
	export interface TWSCalculationEditModel {
		id: number;
		name: string;
		projectId: number;
		projectNumber: string;
		inputMethod: Calculation.InputMethodModel;
		waterSystem: Calculation.WaterSystemModel;
		tankSelection: Calculation.TankSelectionModel;
	}
	export enum TWSPumpType {
		No = 0,
		Single = 1,
		Double = 2,
	}
	export interface TWSSummaryImages {
		flowChart: string;
	}
	export interface WaterSystemMatchingTapWaterSystemResultModel {
		matchingTapWaterSystemModels: Calculation.MatchingTapWaterSystemModel[];
		matchingTapWaterSystemOptionModels: Calculation.WaterSystemOptionModel[];
		matchingWaterSystemTechnicalDataModel: Calculation.WaterSystemTechnicalDataModel;
	}
	export interface WaterSystemModel {
		design: any;
		waterSystemSelection: Calculation.WaterSystemSelectionModel;
		selectedTapWaterSystemModel: Calculation.MatchingTapWaterSystemModel;
		selectedTWSOptions: Calculation.WaterSystemOptionModel[];
		results: Calculation.WaterSystemMatchingTapWaterSystemResultModel;
	}
	export interface WaterSystemOptionModel {
		artNo: string;
		description: string;
		oneOfGroup?: number;
		familyMatch: string;
		seriesMatch: string;
		pilot: boolean;
		weight: number;
	}
	export interface WaterSystemSelectionModel {
		temperatureProgram: string;
		primaryPump: Calculation.TWSPumpType;
		secondaryPump: Calculation.TWSPumpType;
		controlValve: Calculation.ControlValveType;
		heType: any;
	}
	export interface WaterSystemTechnicalDataGeneralModel {
		controller: string;
		maxElectConsumption: string;
		overallDimensions: string;
		twsWeight: number;
	}
	export interface WaterSystemTechnicalDataHeatExchangerModel {
		heatExchangerType: string;
		platesType: string;
		platesNumber: string;
		insulation: string;
		heatExchangerTypeAsText: string;
	}
	export interface WaterSystemTechnicalDataModel {
		productFamily: string;
		productFamilyDisplayName: string;
		productSeries: string;
		productArticleNumber: string;
		temperatureProgram: string;
		requiredCapacity?: number;
		nominalCapacity: string;
		marginToMaxCapacityPercent: number;
		primaryPumpModel: Calculation.WaterSystemTechnicalDataPrimaryPumpModel;
		secondaryPumpModel: Calculation.WaterSystemTechnicalDataSecondaryPumpModel;
		heatExchangerModel: Calculation.WaterSystemTechnicalDataHeatExchangerModel;
		generalModel: Calculation.WaterSystemTechnicalDataGeneralModel;
	}
	export interface WaterSystemTechnicalDataPrimaryPumpModel {
		controlValve: string;
		alfaPilotOptionSelected: boolean;
		controlValveType: string;
		primaryFreePressure: string;
		ctrlValveActuator: string;
		inletConnectionDiameter: string;
		outletConnectionDiameter: string;
		primaryInletTemperature: string;
		primaryOutletTemperature: string;
		primaryFlowRate: string;
		extraPrimKit: string;
		extraCvKv?: number;
		pressureDropAtPrimaryFlowRate?: number;
		selectedAquaEfficiencyOption: string;
		freePressure?: number;
		freePressureError: Calculation.SelectedWaterSystemPrimaryPressureErrors;
		is3PSelected: boolean;
		primaryFreePressureAsText: string;
		primaryFreePressureLabel: string;
		controlValveName: string;
		maxPressure: string;
		primaryPump: Calculation.TWSPumpType;
		maxTemperature: string;
		pumpType: string;
		pressureDrop: string;
	}
	export interface WaterSystemTechnicalDataSecondaryPumpModel {
		settingValve: string;
		secondaryInletTemperature: string;
		secondaryOutletTemperature: string;
		secInletConnectionDiameter: string;
		secOutletConnectionDiameter: string;
		tankChargingTime?: number;
		tenMinFlowRate?: number;
		oneHourFlowRate?: number;
		secondaryFlowRate: number;
		maxRecyclingFlowRate: number;
		secondaryPump: Calculation.TWSPumpType;
		pressureDropAtRequestedCapacity?: number;
		pressureDropAtNominalCapacity?: number;
		isNotProductCatalog: boolean;
		pressureDropAtRequestedCapacityAsText: string;
		pressureDropAtNominalCapacityLabel: string;
		secondaryFlowRateAsText: string;
		secondaryPumpAsText: string;
		maxPressure: string;
		primaryPump: Calculation.TWSPumpType;
		maxTemperature: string;
		pumpType: string;
		pressureDrop: string;
	}
}
export namespace Configuration {
	export enum __vite_fix_ignore_me {}
	export enum CircuitType {
		Heating = 0,
		DHW = 1,
		DHWc = 2,
		Cooling = 3,
		ServiceShutOff = 4,
		Primary = 5,
		ColdWater = 6,
		HeatingFlow = 7,
		SummerShutOff = 8,
		TWS = 9,
		Recycling = 10,
		Charging = 11,
		Secondary = 12,
		DHFlow = 13,
		DHRet = 14,
	}
}
export namespace Message {
	export enum __vite_fix_ignore_me {}
	export enum ApplicationType {
		WebSelect = 0,
		TWS = 1,
	}
}
export namespace Selection {
	export enum __vite_fix_ignore_me {}
	export enum AquaTankType {
		NO = 'no',
		AQTEM7BAR = 'aqteM7BAR',
		AQT316TI = 'aqT316TI',
		PRIMARYTANK5BAR = 'primarytanK5BAR',
		AQTHC316TI = 'aqthC316TI',
		REACTIONSTANDARD = 'reactionstandard',
	}
	export interface InputMethodValuesModel {
		capacity?: number;
		volume: number;
		primaryTank: boolean;
		aquaTank: boolean;
		secondaryTank: boolean;
		selectedProduct: string;
		instantaneous: boolean;
	}
	export enum InspectionHole {
		NO = 0,
		HOLE = 1,
		MANHOLE = 2,
	}
	export function getInspectionHoleName(k: InspectionHole): string {
		switch(k) {
			case InspectionHole.NO: return 'No';
			case InspectionHole.HOLE: return 'Hole';
			case InspectionHole.MANHOLE: return 'Man hole';
		}
	}
	export interface MatchingQuantityModel {
		ref: number;
		tankVolume: number;
		madeOfNX: number;
		unitVolL: number;
		material: Selection.TankMaterials;
		materialSlug: string;
	}
	export interface MatchingTankQuantityModel {
		availableMatchingTankQuantities: Selection.MatchingQuantityModel[];
		chosenMatchingTankQuantity: Selection.MatchingQuantityModel;
	}
	export enum ProductFamily {
		AquaGenius = 'aquaGenius',
		AquaFirst = 'aquaFirst',
		AquaEfficiency = 'aquaEfficiency',
		AquaPlate = 'aquaPlate',
		AquaCompact = 'aquaCompact',
		AlfaPilot = 'alfaPilot',
		AquaTank = 'aquaTank',
		TwoPort = 'twoPort',
	}
	export function getProductFamilyName(k: ProductFamily): string {
		switch(k) {
			case ProductFamily.AquaGenius: return 'Aqua genius';
			case ProductFamily.AquaFirst: return 'Aqua first';
			case ProductFamily.AquaEfficiency: return 'Aqua efficiency';
			case ProductFamily.AquaPlate: return 'Aqua plate';
			case ProductFamily.AquaCompact: return 'Aqua compact';
			case ProductFamily.AlfaPilot: return 'Alfa pilot';
			case ProductFamily.AquaTank: return 'Aqua tank';
			case ProductFamily.TwoPort: return '2Port';
		}
	}
	export enum TankFamily {
		PrimaryTank = 'primaryTank',
		AquaTank = 'aquaTank',
	}
	export enum TankInsulation {
		ALL = 'all',
		M0 = 'm0',
		M1 = 'm1',
		M2 = 'm2',
		NEODUL = 'neodul',
	}
	export enum TankMaterials {
		Stainless = 0,
		Enamelled = 1,
		CarbonSteel = 2,
	}
	export function getTankMaterialsName(k: TankMaterials): string {
		switch(k) {
			case TankMaterials.Stainless: return 'Stainless';
			case TankMaterials.Enamelled: return 'Enamelled';
			case TankMaterials.CarbonSteel: return 'Carbon steel';
		}
	}
	export enum TankQuantity {
		All = 'all',
		One = 'one',
		Two = 'two',
		Three = 'three',
	}
	export interface TankResultModel {
		ref: number;
		articleNumber: string;
		tankFamily: string;
		tankValume: number;
		material: string;
		insulation: string;
		inspection: Selection.InspectionHole;
		inspectionSlug: string;
		maxPs: number;
		maxTs: number;
		pscoil: string;
		tscoil: string;
		diam: number;
		height: number;
		description: string;
		flowChart: string;
		technicalDrawing: string;
		image: string;
	}
	export interface TankTechnicalDataFilterModel {
		matchingTankQuantity: Selection.MatchingQuantityModel;
		tankResult: Selection.TankResultModel;
	}
	export interface TankTechnicalDataModel {
		insulation: string;
		insulationDescription: string;
		thermalLoos?: number;
		maxOperatingTemp: number;
		totalHeight: number;
		maxOperatingPressure: number;
		weight: number;
		productFamily: Selection.TankFamily;
		productFamilySlug: string;
		productSeries: string;
		articleName: string;
		quantity: number;
		volume: number;
		tankMaterial: Selection.TankMaterials;
		tankMaterialSlug: string;
		material: string;
		totalDiameter: number;
		tiltHeight: number;
		inspectionHole: string;
		inspectionDiameter: string;
		chargingConnDiam: string;
		coldHotWaterConnectionDiameter: string;
		recyclingConnDiameter: string;
		thermalLossAsText: string;
		productFamilyAsText: string;
		weightAsText: string;
	}
	export enum TankType {
		NoTank = 0,
		PrimaryTank = 1,
		SecondaryTank = 2,
	}
	export function getTankTypeName(k: TankType): string {
		switch(k) {
			case TankType.NoTank: return 'Tank is included in water system';
			case TankType.PrimaryTank: return 'Primary tank';
			case TankType.SecondaryTank: return 'Secondary tank';
		}
	}
}
